import {
  BuildingData,
  InterestedParty,
} from 'src/pages/payment-msi/PaymentMsiV2/types';

export function getLandlordData(
  building: BuildingData | null,
): InterestedParty | null {
  if (!building) {
    return null;
  }
  if (!building.llc && !building.landlord) {
    return null;
  }

  const landlordEmail = building.landlord.email ?? '';
  const landlordFullName = getLandlordFullName(building);

  return {
    email: landlordEmail,
    fullName: landlordFullName,
  };
}

function getLandlordFullName(building: BuildingData): string {
  if (building.llc) {
    return building.llc;
  }

  if (building.landlord.company) {
    return building.landlord.company;
  }

  return building.landlord.name ?? '';
}
